import React from "react";
import "./ScheduleModal.css";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
// dayOfWeek: 0=Sun,1=Mon...6=Sat — remap to Mon-first index
function monFirstIndex(dayOfWeek) {
  return dayOfWeek === 0 ? 6 : dayOfWeek - 1;
}

function formatTime(ts) {
  if (!ts) return "";
  return new Date(ts).toLocaleTimeString("en-US", {
    hour: "numeric", minute: "2-digit", hour12: true
  });
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export default function ScheduleModal({ worker, schedule, weekStart, weekEnd, onClose }) {
  if (!worker) return null;

  const shifts      = schedule?.shifts || [];
  const totalHours  = schedule?.totalHours || 0;
  const isOvertime  = totalHours >= 40;

  // Group shifts by Mon-first day index (0=Mon ... 6=Sun)
  const byDay = Array.from({ length: 7 }, () => []);
  shifts.forEach(s => {
    const idx = monFirstIndex(s.dayOfWeek);
    byDay[idx].push(s);
  });

  // Compute week dates for column headers
  const weekDates = DAYS.map((_, i) => {
    if (!weekStart) return "";
    const d = new Date(weekStart + "T00:00:00");
    d.setDate(d.getDate() + i);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="modal-header">
          <div className="modal-title-block">
            <div className="modal-name">{worker.firstName} {worker.lastName}</div>
            <div className="modal-week">
              Week of {formatDate(weekStart)} – {formatDate(weekEnd)}
            </div>
          </div>
          <div className="modal-hours-block">
            <div className={`modal-total-hours ${isOvertime ? "overtime" : ""}`}>
              {totalHours.toFixed(1)} hrs
            </div>
            {isOvertime && (
              <div className="modal-overtime-badge">⚠ 40+ hrs</div>
            )}
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Mon–Sun grid */}
        <div className="modal-grid">
          {DAYS.map((day, i) => {
            const dayShifts = byDay[i];
            const today = new Date();
            const colDate = weekStart ? new Date(weekStart + "T00:00:00") : null;
            if (colDate) colDate.setDate(colDate.getDate() + i);
            const isToday = colDate && colDate.toDateString() === today.toDateString();

            return (
              <div key={day} className={`day-col ${isToday ? "day-col-today" : ""}`}>
                <div className="day-header">
                  <span className="day-name">{day}</span>
                  <span className="day-date">{weekDates[i]}</span>
                </div>
                <div className="day-shifts">
                  {dayShifts.length === 0 ? (
                    <div className="day-empty">—</div>
                  ) : (
                    dayShifts.map(s => (
                      <div key={s.id} className="shift-block">
                        <div className="shift-client">{s.clientName}</div>
                        <div className="shift-time">
                          {formatTime(s.start)} – {formatTime(s.end)}
                        </div>
                        <div className="shift-hours">{s.hours.toFixed(1)}h</div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        {shifts.length === 0 && (
          <div className="modal-footer-empty">No shifts scheduled this week</div>
        )}
      </div>
    </div>
  );
}
